import dynamic from "next/dynamic";
const HoverableCardsGridComponent = dynamic(()=>import("./hoverable-cards-grid-component"));
import HoverableCardsGridConfig from "./hoverable-cards-grid-config";
import HoverableCardsGridAdvancedConfig from "./hoverable-cards-grid-advanced-config";
export default {
    HoverableCardsGridComponent,
    HoverableCardsGridConfig,
    HoverableCardsGridAdvancedConfig
};
